import { NavLink } from "react-router-dom";
import "./SideMenu.scss";

const SideMenu = () => {
  const menuItems = [
    { label: "システム設定", path: "/master/systemsetting" },
    { label: "ユーザ", path: "/master/user" },
    { label: "権限", path: "/master/role" },
    { label: "車種", path: "/master/vehicleclass" },
    { label: "固定音声", path: "/master/announcement" },
    { label: "確認要求種別", path: "/master/requestclass" },
    { label: "メッセージ", path: "/master/screenmessage" },
    { label: "停留所", path: "/master/basestop" },
  ];

  return (
    <aside className="sideMenu">
      <ul>
        {menuItems.map(({ label, path }) => (
          <li key={path}>
            <NavLink
              to={path}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default SideMenu;
